export var EASE_IN = 'cubicBezier(0.64, 0, 0.78, 0)';
export var EASE_OUT = 'cubicBezier(0.22, 1, 0.36, 1)';
export var EASE_IN_OUT = 'cubicBezier(0.83, 0, 0.17, 1)';
export var frameToMs = function (value) {
    return (value * 1000) / 60;
};
